/**
 * Apply the Design System to a single Drupal behavior
 */

import { enableAllComponents } from '../../source/consumer';

import './scss/_drupal-styles.scss';

Drupal.behaviors.designSystem = {
  attach($context) {
    // Modify settings here as needed to meet requirements of components
    const componentSettings = {
      // expand/collapse settings!
      layout: {
        strings: {
          seeLessText: Drupal.t('See Less'),
          seeMoreText: Drupal.t('See More'),
        },
      },
    };

    enableAllComponents($context, componentSettings);
  },
};
